import React from "react";
import styled from "styled-components";
import { Button, Modal } from "components/bootstrap";
import { useTranslation } from "react-i18next";
import EntitiesList from "./EntitiesList/EntitiesList";
const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const AddEntitiesModal = ({ collectionId, onClose }) => {
  const { t } = useTranslation("enterprise_collections");
  return /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: onClose, fullScreen: true }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, t("add_entities_modal.title"))), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(EntitiesList, { collectionId })), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(StyledFooter, null, /* @__PURE__ */ React.createElement(Button, { onClick: onClose }, t("add_entities_modal.close")))));
};
export default AddEntitiesModal;
